import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames';

import ControlButton from '../Shared/ControlButton';
import PetList from './PetList';
import PetPickerFooter from './PetPickerFooter';

import { removeNewnessFromPets } from '../../../actions/allPets';
import { setShuffleAsync } from '../../../actions/activePet';
import { clearPurchases } from '../../../actions/purchases';
import getNewPets from '../../../selectors/getNewPets';
import getCollectedPets from '../../../selectors/getCollectedPets';
import { PURCHASES_NOT_SUPPORTED_FOR_COUNTRY } from '../../../constants';

class PetPicker extends React.Component {
	constructor() {
		super();

		this.state = {
			isOpen: false,
			toggleClicks: 0,
		};

		this.shuffleClosesPetPickerTimeout = null;

		this.getClassNames = this.getClassNames.bind(this);
		this.togglePetPicker = this.togglePetPicker.bind(this);
		this.closePetPicker = this.closePetPicker.bind(this);
		this.onKeyPress = this.onKeyPress.bind(this);
		this.renderShuffle = this.renderShuffle.bind(this);
		this.setShuffle = this.setShuffle.bind(this);
	}

	componentWillMount() {
		document.addEventListener("keydown", this.onKeyPress);
	}

	onKeyPress(e) {
		if (e.code === 'Escape' && this.state.isOpen) {
			this.closePetPicker();
		}
	}

	getClassNames() {
		return classnames('pet-picker', {
			'pet-picker--is-open': this.state.isOpen,
			'pet-picker--has-new-pets': this.props.hasNewPets && !this.state.isOpen,
		});
	}

	shouldClearNewPets() {
		if (this.state.toggleClicks === 1) this.props.clearNewPets();
	}

	shouldClearPurchases() {
		if (!_.isEmpty(this.props.purchases)) this.props.clearPurchases();
	}

	closePetPicker() {
		this.setState({ isOpen: false }, this.shouldClearPurchases);
	}

	openPetPicker() {
		this.setState({ isOpen: true });
	}

	togglePetPicker() {
		const lastToggleClicks = this.state.toggleClicks;
		this.setState({ toggleClicks: lastToggleClicks + 1 }, this.shouldClearNewPets);

		if (this.state.isOpen) {
			this.closePetPicker();
		} else {
			this.openPetPicker();
		}
	}

	setShuffle() {
		const lastShuffleState = this.props.shuffleIsActive;

		clearTimeout(this.shuffleClosesPetPickerTimeout);

		this.props.setShuffle();

		// Close the petpicker if shuffle is now active
		if (!lastShuffleState) {
			this.shuffleClosesPetPickerTimeout = setTimeout(() => {
				this.closePetPicker();
			}, 200);
		}
	}

	renderShuffle() {
		if (!this.props.shouldShowShuffle) {
			return null;
		}

		return (
			<ControlButton
				shuffle
				isActive={this.props.shuffleIsActive}
				callback={this.setShuffle}
			/>
		);
	}

	render() {
		if (this.props.purchasesNotSupportedForCountry) {
			return null;
		}

		return (
			<div className={this.getClassNames()} onKeyPress={this.onKeyPress}>
				<div className="pet-picker__controls">
					<ControlButton
						className="pet-picker"
						iconName="House"
						isActive={this.state.isOpen}
						hasNotification={this.props.hasNewPets && !this.state.isOpen}
						notificationMessage="New Pets!"
						label="Pets"
						callback={this.togglePetPicker}
					/>
					{this.renderShuffle()}
					<ControlButton
						className="close-pet-picker"
						iconName="X"
						callback={this.togglePetPicker}
					/>
				</div>

				<div className="pet-picker__page">
					<PetList
						isOpen={this.state.isOpen}
						closePetPicker={this.closePetPicker}
					/>
					{/*<PetPickerFooter />*/}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	hasNewPets: !_.isEmpty(getNewPets(state.allPets)),
	shouldShowShuffle: getCollectedPets(state.allPets).length > 1,
	shuffleIsActive: state.activePet.shuffle,
	purchases: state.purchases,
	purchasesNotSupportedForCountry: state.lastVerification.error === PURCHASES_NOT_SUPPORTED_FOR_COUNTRY,
});

const mapDispatchToProps = dispatch => ({
	clearNewPets: () => {
		dispatch(removeNewnessFromPets());
	},
	setShuffle: () => {
		dispatch(setShuffleAsync());
	},
	clearPurchases: () => {
		dispatch(clearPurchases());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(PetPicker);



// WEBPACK FOOTER //
// ./src/components/Extension/PetPicker/index.js